(()=>{
const VD_NATIVE_C1_SERVICE="https://studio.vinyl-disorder.com";
// Native C1 adapter: one Shadow DOM on the Shopify page; no nested browsing context.
function vdPrepareNativeC1(frame) {
  const url = new URL(frame.dataset.chameleonNativeSrc || frame.src, location.href);
  if (url.origin !== 'https://studio.vinyl-disorder.com' || url.searchParams.get('experience') !== 'simple' || frame.closest('[data-chameleon-private-studio]') || /c4/.test(url.pathname)) return frame;
  url.pathname='/create';const mount=document.createElement('div'); mount.dataset.chameleonStudioFrame='';mount.dataset.chameleonNativeC1='';mount.setAttribute('role','region');mount.setAttribute('aria-label',frame.getAttribute('title')||frame.getAttribute('aria-label')||'Sticker designer');mount.src=url.href;
  const shell=mount.attachShadow({mode:'open'}),html=document.createElement('div'),head=document.createElement('div'),body=document.createElement('div'),root=document.createElement('div');
  html.className='vd-native-document';body.className='vd-native-body';root.id='root';body.append(root);html.append(head,body);shell.append(html);
  const loading=document.createElement('div');loading.className='vd-native-loading';loading.setAttribute('role','status');loading.textContent='Loading your sticker builder…';body.prepend(loading);
  const reset=document.createElement('style');reset.textContent=':host{display:block;width:100%;color:#111827;background:white;font:16px Arial,Helvetica,sans-serif}.vd-native-document,.vd-native-body{margin:0;min-height:0}.vd-native-loading{padding:48px 20px;text-align:center}.vd-native-body #root{min-width:0}';head.append(reset);
  const listeners=new EventTarget(),local={},host={location:window.location},nativeLocation=new URL(url),storage=window.sessionStorage;
  nativeLocation.assign=value=>window.location.assign(new URL(value,nativeLocation).href);nativeLocation.replace=value=>window.location.replace(new URL(value,nativeLocation).href);nativeLocation.reload=()=>window.location.reload();const resolve=(value)=>{if(typeof value!=='string')return value;if(value.startsWith('/')&&!value.startsWith('//'))return new URL(value,url.origin).href;return value};
  const nativeFetch=(input,options)=>{let target=typeof input==='string'?resolve(input):input;if(typeof target==='string'){const api=new URL(target,location.href);if(api.origin===url.origin&&api.pathname.startsWith('/api/')){api.pathname='/c1-native/v1'+api.pathname;target=new URL(api.pathname+api.search,VD_NATIVE_C1_SERVICE).href}}return window.fetch(target,options)};
  let gestureOwned=false;const scopedListeners=new Map();shell.addEventListener('pointerdown',()=>{gestureOwned=true},{capture:true});window.addEventListener('pointerup',()=>setTimeout(()=>{gestureOwned=false},0),{capture:true});window.addEventListener('pointercancel',()=>setTimeout(()=>{gestureOwned=false},0),{capture:true});
  const scopeEvent=(event)=>new Proxy(event,{get(target,key){if(key==='target')return target.composedPath?.()[0]||target.target;const value=Reflect.get(target,key,target);return typeof value==='function'?value.bind(target):value}});
  function scopedEventListener(target,action,type,listener,options){const interactive=/^(?:key|pointer|mouse|touch|wheel|click|focus|blur|input|change)/.test(type);if(!interactive)return target[action](type,listener,options);let byTarget=scopedListeners.get(target);if(!byTarget)scopedListeners.set(target,byTarget=new Map());const capture=typeof options==='boolean'?options:!!options?.capture,key=type+':'+capture;let entries=byTarget.get(key);if(!entries)byTarget.set(key,entries=new Map());if(action==='removeEventListener'){const wrapped=entries.get(listener);if(wrapped){target.removeEventListener(type,wrapped,options);entries.delete(listener)}return}if(entries.has(listener))return;const wrapped=event=>{const path=event.composedPath?.()||[];if(!path.includes(shell)&&!gestureOwned)return;const scoped=scopeEvent(event);if(typeof listener==='function')listener.call(nativeWindow,scoped);else listener?.handleEvent?.(scoped)};entries.set(listener,wrapped);target.addEventListener(type,wrapped,options);}
  const scopedDocument=new Proxy(document,{get(target,key){if(key==='documentElement')return html;if(key==='location')return nativeLocation;if(key==='defaultView')return nativeWindow;if(key==='contains')return node=>shell.contains(node);if(key==='elementFromPoint'||key==='elementsFromPoint')return typeof shell[key]==='function'?shell[key].bind(shell):target[key].bind(target);if(key==='body')return body;if(key==='head')return head;if(key==='referrer')return location.href;if(key==='URL'||key==='baseURI')return url.href;if(key==='getElementById')return id=>shell.getElementById(id);if(key==='querySelector')return selector=>selector==='body'?body:selector==='html'?html:shell.querySelector(selector);if(key==='querySelectorAll')return selector=>shell.querySelectorAll(selector);if(key==='addEventListener'||key==='removeEventListener')return(type,listener,options)=>scopedEventListener(document,key,type,listener,options);if(key==='activeElement')return shell.activeElement||body;if(key==='scrollingElement')return document.scrollingElement;const value=Reflect.get(target,key,target);return typeof value==='function'?value.bind(target):value}});
  let nativeWindow;
  const runtime={postMessage(data,targetOrigin){if(targetOrigin!==url.origin&&targetOrigin!=='*')return;listeners.dispatchEvent(new MessageEvent('message',{data,origin:location.origin,source:host}));}};
  mount.__vdNativeEvents=[];host.postMessage=(data,targetOrigin)=>{mount.__vdNativeEvents.push({direction:"out",type:data?.type});if(targetOrigin!==location.origin&&targetOrigin!=='*')return;if(data?.type==='CHAMELEON_PAGE_SCROLL_DELTA'||data?.type==='CHAMELEON_PAGE_SCROLL_STATE_REQUEST')return;if(data?.type==='CHAMELEON_SIMPLE_DEAL_HEIGHT'||data?.type==='CHAMELEON_STUDIO_HEIGHT'){loading.remove();mount.dataset.nativeReady='true';return}mount.dispatchEvent(new CustomEvent('vd:c1:message',{bubbles:true,detail:{runtime,data}}));};
  // EventTarget's MessageEvent.source only accepts Window; the bridge uses a plain
  // local event with immutable source identity, without manufacturing an origin.
  runtime.postMessage=(data,targetOrigin)=>{mount.__vdNativeEvents.push({direction:"in",type:data?.type,ok:data?.ok,error:data?.error});if(targetOrigin!==url.origin&&targetOrigin!=='*')return;const e=new Event('message');Object.defineProperties(e,{data:{value:data},origin:{value:location.origin},source:{value:host}});listeners.dispatchEvent(e)};
  const history={pushState(state,unused,next){if(next)nativeLocation.href=new URL(next,nativeLocation).href;local.historyState=state},replaceState(state,unused,next){if(next)nativeLocation.href=new URL(next,nativeLocation).href;local.historyState=state},get state(){return local.historyState??null}};
  nativeWindow=new Proxy(window,{get(target,key){if(key==='window'||key==='self')return nativeWindow;if(key==='parent'||key==='top')return host;if(key==='document')return scopedDocument;if(key==='location')return nativeLocation;if(key==='history')return history;if(key==='Shopify')return undefined;if(key==='__vdC1InitialConfig')return local.initialConfig;if(key==='addEventListener'||key==='removeEventListener')return(type,listener,opts)=>type==='message'?listeners[key](type,listener,opts):scopedEventListener(target,key,type,listener,opts);if(key==='fetch')return nativeFetch;if(key in local)return local[key];const value=Reflect.get(target,key,target);return typeof value==='function'&&!/^[A-Z]/.test(String(key))?value.bind(target):value},set(target,key,value){local[key]=value;return true}});
  const handle=url.searchParams.get('deal');local.initialConfig={handle,startedAt:Date.now(),promise:nativeFetch('/api/deals/simple-1000?handle='+encodeURIComponent(handle),{cache:'no-store'})};local.initialConfig.promise.catch(()=>{});
  class NativeWorker extends Worker {constructor(input,options){const workerUrl=new URL(mount.__vdNativeContext.assetUrl(new URL(input,url).href));if(workerUrl.origin===url.origin||workerUrl.origin===new URL(VD_NATIVE_C1_SERVICE).origin){const source=options?.type==="module"?"import "+JSON.stringify(workerUrl.href):"importScripts("+JSON.stringify(workerUrl.href)+")";const blob=URL.createObjectURL(new Blob([source],{type:"text/javascript"}));super(blob,options);this.nativeBlob=blob;}else super(input,options);}terminate(){super.terminate();if(this.nativeBlob)URL.revokeObjectURL(this.nativeBlob)}} class NativeMutationObserver extends MutationObserver {observe(node,options){return super.observe(node===scopedDocument?html:node,options)}} mount.__vdNativeRuntime=runtime;mount.__vdNativeContext={window:nativeWindow,document:scopedDocument,location:nativeLocation,fetch:nativeFetch,root,head,shell,Worker:NativeWorker,MutationObserver:NativeMutationObserver,url:url.href,assetMap:{},assetUrl(input){const asset=new URL(input,url);const mapped=this.assetMap[asset.href];if(mapped)return new URL(mapped,VD_NATIVE_C1_SERVICE).href;if(asset.origin===url.origin&&/^\/(?:photo-effects-assets|bumper-assets|vendor|photo-segmentation|c1-performance-assets|fonts|template-assets|assets|brand|deals)\//.test(asset.pathname))return new URL("/c1-native/v1/public"+asset.pathname+asset.search,VD_NATIVE_C1_SERVICE).href;return asset.href}};
  const block=frame.closest('[data-chameleon-shopify-studio]');block.dataset.chameleonNative='true';frame.parentElement.removeAttribute('data-vd-editor-loading');frame.replaceWith(mount);
  const css=document.createElement('style');css.textContent='[data-chameleon-native="true"]{height:auto!important;min-height:0!important;max-height:none!important;overflow:visible!important}[data-chameleon-native-c1]{display:block!important;width:100%!important;height:auto!important;min-height:0!important;max-height:none!important;overflow:visible!important}';document.head.append(css);
  mount.__vdNativeStart=async()=>{
    try {const family=url.pathname.includes('bumper-assets')?'bumper':handle==='chameleon-cut-to-shape-stickers'?'bulk':(['bumper-stickers','circle-stickers','square-stickers','kiss-cut-stickers','clear-stickers'].includes(handle)?'bumper':'industry');
      // The loader selects the actual client family from the canonical Studio HTML.
      const page=await fetch(new URL('/c1-native/v1/bootstrap'+url.search,VD_NATIVE_C1_SERVICE),{credentials:'omit'});if(!page.ok)throw Error('Builder configuration could not load');const source=await page.text();const parsed=new DOMParser().parseFromString(source,'text/html');const client=[...parsed.querySelectorAll('script[type="module"][src]')].find(e=>/\/assets\/index-/.test(e.getAttribute('src')));if(!client)throw Error('Builder client missing');for(const existing of parsed.querySelectorAll('style')){const inline=document.createElement('style');inline.textContent=existing.textContent;head.append(inline)}const clientPath=client.getAttribute('src');const kind=clientPath.includes('/bulk/')?'bulk':clientPath.includes('/bumper-assets/')?'bumper':'industry';
      window.__vdC1NativeContext=mount.__vdNativeContext;
      const sheet=document.createElement('link');sheet.rel='stylesheet';sheet.href=VD_NATIVE_C1_SERVICE+'/c1-native/v1/assets/20261023-vector/'+kind+'.css';await new Promise((resolve,reject)=>{sheet.onload=resolve;sheet.onerror=()=>reject(Error('Builder styles could not load'));head.append(sheet)});
      mount.__vdNativeContext.kind=kind;mount.__vdNativeContext.clientUrl=new URL(clientPath,url).href;await import(VD_NATIVE_C1_SERVICE+'/c1-native/v1/assets/20261023-vector/'+kind+'.js');mount.dispatchEvent(new Event('load'));window.dispatchEvent(new Event('vd:c1:mounted'));
      setTimeout(()=>{if(!mount.dataset.nativeReady){loading.textContent='The builder hasn’t connected yet. Please reload this page.'}},20000);
    }catch(e){loading.textContent='The builder could not load. Please reload this page.';mount.dataset.nativeError=String(e);console.error(e)}
  };
  return mount;
}






(() => {
  "use strict";

  // MISSION_050D_RELIABLE_CART_NAVIGATION

  const BRIDGE_VERSION = "049G-3";
  const CANONICAL_STOREFRONT_ORIGIN = "https://vinyldisorder.com";
  const RETURN_QUEUE_STORAGE_KEY = "chameleon:return-to-queue:v1";
  const LEGACY_REORDER_PARAMETER_NAMES = [
    "vd_direct_reorder",
    "vd_saved_design_id",
    "vd_original_order_number",
    "vd_file_pull_order_number",
    "vd_reorder_from",
    "vd_design_name",
    "vd_production_quantity",
    "vd_saved_specs",
    "vd_original_extra_options",
    "vd_artwork_url",
    "vd_artwork_preview_url",
    "vd_reorder_note",
    "vd_option_selection",
    "vd_option_size",
    "vd_option_width",
    "vd_option_height",
    "vd_option_quantity",
    "vd_option_cut_shape",
    "vd_option_material",
    "vd_option_finish",
    "vd_option_color",
    "vd_option_reverse",
    "vd_option_extras",
    "vd_option_fields",
  ];

  const getLegacyReorderPayload = () => {
    const searchParams = new URL(window.location.href).searchParams;
    if (searchParams.get("vd_chameleon_reorder") !== "1") return null;

    const payload = {};
    for (const name of LEGACY_REORDER_PARAMETER_NAMES) {
      const value = String(searchParams.get(name) || "").trim();
      if (value) payload[name] = value.slice(0, 28000);
    }

    return payload.vd_saved_design_id ? payload : null;
  };

  const legacyReorderPayload = getLegacyReorderPayload();

  // A Shopify cart cookie created on a www or legacy storefront alias can be
  // lost when Shopify redirects the cart to the bare production domain. Move
  // the product page into the canonical first-party session before the Studio
  // host performs any Ajax cart work.
  if (
    [
      "www.vinyldisorder.com",
      "vinyl-disorder.com",
      "www.vinyl-disorder.com",
    ].includes(window.location.hostname.toLowerCase())
  ) {
    const canonicalUrl = new URL(window.location.href);
    canonicalUrl.protocol = "https:";
    canonicalUrl.host = new URL(CANONICAL_STOREFRONT_ORIGIN).host;
    window.location.replace(canonicalUrl.toString());
    return;
  }
  document.querySelectorAll("iframe[data-chameleon-studio-frame], [data-chameleon-native-placeholder]").forEach(vdPrepareNativeC1);
  const blocks = Array.from(
    document.querySelectorAll("[data-chameleon-shopify-studio]"),
  );

  // MISSION_051K_FULL_BLEED_CUSTOMER_STUDIO
  // The public CHAMELEON page owns the full viewport below the Shopify header.
  // This is scoped only to pages that actually contain the public Studio block.
  const publicBlocks = blocks.filter((block) => !block.hasAttribute("data-chameleon-private-studio"));
  let sizePublicStudio = () => {};

  if (publicBlocks.length > 0) {
    document.documentElement.classList.add("chameleon-public-studio-page");
    document.body.classList.add("chameleon-public-studio-page");

    // MISSION_051K_PUBLIC_MOBILE_HEADER_NORMAL_FLOW
    // Shopify reapplies sticky header classes while scrolling. Keep the exact
    // storefront header section in normal document flow on public Studio pages.
    const syncPublicMobileHeaderFlow = () => {
      const headerSection = document.getElementById("shopify-section-header");
      if (!headerSection) return;
      const isMobile = window.matchMedia("(max-width: 989px)").matches;
      if (isMobile) {
        headerSection.dataset.chameleonMobileHeaderFlow = "true";
        headerSection.style.setProperty("position", "relative", "important");
        headerSection.style.setProperty("top", "auto", "important");
        headerSection.style.setProperty("transform", "none", "important");
        headerSection.classList.remove(
          "shopify-section-header-sticky",
          "shopify-section-header-hidden",
          "animate",
        );
        return;
      }
      if (headerSection.dataset.chameleonMobileHeaderFlow === "true") {
        delete headerSection.dataset.chameleonMobileHeaderFlow;
        headerSection.style.removeProperty("position");
        headerSection.style.removeProperty("top");
        headerSection.style.removeProperty("transform");
      }
    };

    let mobileHeaderSyncFrame = 0;
    const queuePublicMobileHeaderFlow = () => {
      if (mobileHeaderSyncFrame) return;
      mobileHeaderSyncFrame = window.requestAnimationFrame(() => {
        mobileHeaderSyncFrame = 0;
        syncPublicMobileHeaderFlow();
      });
    };

    syncPublicMobileHeaderFlow();
    window.addEventListener("scroll", queuePublicMobileHeaderFlow, { passive: true });
    window.addEventListener("resize", queuePublicMobileHeaderFlow, { passive: true });
    window.addEventListener("orientationchange", queuePublicMobileHeaderFlow, { passive: true });
    window.setTimeout(syncPublicMobileHeaderFlow, 120);
    window.setTimeout(syncPublicMobileHeaderFlow, 600);

    // Phones and tablets keep the stable visual-viewport handoff. Desktop uses
    // the Studio's measured content height so the storefront owns one scroll.
    sizePublicStudio = () => {
      const visualViewport = window.visualViewport;
      const viewportHeight = Math.round(visualViewport?.height || window.innerHeight);
      const phone = window.matchMedia("(max-width: 749px)").matches;
      const desktop = window.matchMedia("(min-width: 1181px)").matches;

      for (const block of publicBlocks) {
        if (block.dataset.chameleonNative === "true") continue;
        const measuredHeight = Number(block.dataset.chameleonContentHeight || 0);
        const studioHeight = desktop && measuredHeight >= 520
          ? measuredHeight
          : Math.max(phone ? 320 : desktop ? 1100 : 520, viewportHeight);
        block.style.setProperty("--chameleon-studio-height", `${studioHeight}px`);
      }
    };

    sizePublicStudio();
    window.addEventListener("resize", sizePublicStudio, { passive: true });
    window.addEventListener("orientationchange", sizePublicStudio, { passive: true });
    window.visualViewport?.addEventListener("resize", sizePublicStudio, { passive: true });
    window.visualViewport?.addEventListener("scroll", sizePublicStudio, { passive: true });
    window.setTimeout(sizePublicStudio, 120);
    window.setTimeout(sizePublicStudio, 600);
  }
  const REQUIRED_PROPERTIES = [
    "Finished size",
    "Sticker quantity",
    "Material",
    "Laminate",
    "Proof status",
    "_CHAMELEON Checkout Job ID",
    "_CHAMELEON Design ID",
    "_CHAMELEON Proof Status",
    "_CHAMELEON Proof Fingerprint",
    "_CHAMELEON Width",
    "_CHAMELEON Height",
    "_CHAMELEON Sticker Quantity",
    "_CHAMELEON Material",
    "_CHAMELEON Laminate",
    "_CHAMELEON Intended Price Cents",
    "_CHAMELEON Cart Bridge Version",
    "_CHAMELEON Design Summary",
    "_CHAMELEON Original Master SHA256",
    "_CHAMELEON Original Color Mode",
  ];

  const requiredPropertiesFor = (properties) => {
    const pricingVersion = properties["_Pricing version"] || properties["Pricing version"];
    return [
      ...REQUIRED_PROPERTIES,
      properties["_Pricing version"] ? "_Pricing version" : "Pricing version",
      ...(String(pricingVersion || "").startsWith("DEAL-")
        ? ["_CHAMELEON Deal Handle"]
        : []),
      ...(properties["_CHAMELEON Proof Status"] === "approved"
        ? ["Approved proof", "_CHAMELEON Approved Proof URL", "_CHAMELEON Approved At"]
        : []),
    ];
  };

  const ALLOWED_PROPERTIES = new Set([
    ...REQUIRED_PROPERTIES,
    "Pricing version",
    "Design reference",
    "Secure file reference",
    "_Pricing version",
    "_Design reference",
    "_Secure file reference",
    "Laminate price adjustment",
    "Laminate price multiplier",
    "Sticker total price",
    "_Sticker total price",
    "Price per sticker",
    "Premium Vinyl interpolated base",
    "Material price multiplier",
    "_CHAMELEON Pricing Input",
    "_CHAMELEON Deal Handle",
    "_CHAMELEON Deal Product ID",
    "_CHAMELEON Deal Variant ID",
    "Deal",
    "Deal terms",
    "Package",
    "Wrap quantity",
    "Package total price",
    "Price per pair",
    "Hole guide",
    "Shape",
    "Edge / bleed",
    "Edge thickness",
    "Border color",
    "_Border color",
    "Manual proof required",
    "Manual proof notes",
    "Notes for our team",
    "Instagram shoutout (opt-in)",
    "Proof approved by",
    "Approved proof",
    "Approval",
    "_CHAMELEON Approved Proof URL",
    "_Proof approved by",
    "_CHAMELEON Approved At",
    "_CHAMELEON Project ID",
    "_CHAMELEON Project Revision",
    "_CHAMELEON Layer Count",
    "_CHAMELEON Artwork SHA256",
    "_CHAMELEON Preview URL",
    "_CHAMELEON Preview Data",
    "_CHAMELEON Preview Alt",
    "_CHAMELEON Original Master SHA256",
    "_CHAMELEON Original Color Mode",
    "_CHAMELEON Studio Return URL",
    "VD Reorder",
    "Artwork Change",
    "File Pull Order Number",
    "Production File Note",
    "Original Order Number",
    "Reorder From Order",
    "Saved Design ID",
    "VD Reorder Note",
    "Design Name",
    "Production Quantity",
    "Production fingerprint",
    "Production separations",
    "Added editable layers",
    "_Production fingerprint",
    "_Production separations",
    "_Added editable layers",
  ]);

  const root = window.Shopify?.routes?.root || "/";

  const rememberStudioQueue = () => {
    try {
      window.sessionStorage.setItem(
        RETURN_QUEUE_STORAGE_KEY,
        JSON.stringify({ url: window.location.href, savedAt: Date.now() }),
      );
    } catch {
      // Same-tab checkout still works if storage is unavailable.
    }
  };

  const openVerifiedCart = () => {
    const cartUrl = new URL(`${root}cart`, window.location.origin).toString();
    rememberStudioQueue();
    window.location.assign(cartUrl);
  };

  const fetchCart = async () => {
    const response = await fetch(`${root}cart.js`, {
      headers: { Accept: "application/json" },
      cache: "no-store",
    });

    if (!response.ok) {
      throw new Error("Shopify could not return the cart for verification.");
    }

    return response.json();
  };

  const findVerifiedLine = async (jobId) => {
    let lastCart = null;
    let lastError = null;

    for (let attempt = 0; attempt < 8; attempt += 1) {
      try {
        const cart = await fetchCart();
        lastCart = cart;
        const line = (cart.items || []).find(
          (item) =>
            item?.properties?.["_CHAMELEON Checkout Job ID"] === jobId,
        );

        if (line) return { cart, line };
      } catch (error) {
        lastError = error;
      }

      await new Promise((resolve) => window.setTimeout(resolve, 250));
    }

    if (lastCart) return { cart: lastCart, line: null };
    if (lastError) throw lastError;
    return { cart: await fetchCart(), line: null };
  };


  const removeUnsafeLine = async (lineKey) => {
    if (!lineKey) return;

    const response = await fetch(`${root}cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0,
      }),
    });

    if (!response.ok) {
      throw new Error(
        "Shopify returned an unsafe carrier price and the line could not be removed automatically. Please empty the cart before continuing.",
      );
    }
  };

  for (const block of blocks) {
    const frame = block.querySelector("[data-chameleon-studio-frame]");
    if (frame?.__vdNativeRuntime) { if (frame.dataset.vdNativeBound) continue; frame.dataset.vdNativeBound = "true"; }
    const configuredVariantId = Number(
      block.dataset.chameleonVariantId || 0,
    );
    const configuredDealHandle = block.dataset.chameleonDealHandle || "";
    const studioUrl =
      block.dataset.chameleonStudioUrl ||
      "https://studio.vinyl-disorder.com";
    const privateToken = block.dataset.chameleonPrivateToken || "";
    const privateParameter =
      block.dataset.chameleonPrivateParameter ||
      "chameleon_checkout";
    const privateMode = block.hasAttribute(
      "data-chameleon-private-studio",
    );
    let studioOrigin;

    try {
      studioOrigin = new URL(studioUrl, window.location.href).origin;
    } catch {
      continue;
    }

    if (
      !(frame instanceof HTMLIFrameElement) && !frame?.__vdNativeRuntime ||
      !Number.isSafeInteger(configuredVariantId) ||
      configuredVariantId <= 0
    ) {
      continue;
    }

    if (privateMode) {
      const supplied = new URLSearchParams(window.location.search).get(
        privateParameter,
      );

      if (!privateToken || supplied !== privateToken) {
        block.remove();
        continue;
      }

      block.hidden = false;
      document.documentElement.classList.add(
        "chameleon-private-checkout-open",
      );

      block
        .querySelector("[data-chameleon-private-close]")
        ?.addEventListener("click", () => {
          block.remove();
          document.documentElement.classList.remove(
            "chameleon-private-checkout-open",
          );
        });
    }

    const postToStudio = (message) => {
      (frame.__vdNativeRuntime || frame.contentWindow)?.postMessage(message, studioOrigin);
    };
    let legacyReorderImportSettled = false;
    const legacyReorderRetryTimers = [];

    const sendLegacyReorderImport = () => {
      if (!legacyReorderPayload || privateMode || legacyReorderImportSettled) return;
      postToStudio({
        type: "CHAMELEON_LEGACY_REORDER_IMPORT",
        bridgeVersion: BRIDGE_VERSION,
        payload: legacyReorderPayload,
      });
    };

    frame.addEventListener("load", () => {
      postToStudio({
        type: "CHAMELEON_SHOPIFY_HOST_READY",
        bridgeVersion: BRIDGE_VERSION,
        variantId: configuredVariantId,
        privateMode,
      });
      sendLegacyReorderImport();
    });

    (()=>{const receive=async (event) => {
      if (
        event.source !== (frame.__vdNativeRuntime || frame.contentWindow) ||
        (!event.nativeValidated && event.origin !== studioOrigin)
      ) {
        return;
      }

      const data = event.data;

      if (!data) return;

      if (data.type === "CHAMELEON_LEGACY_REORDER_RESULT") {
        if (
          data.bridgeVersion === BRIDGE_VERSION &&
          String(data.savedDesignId || "") === legacyReorderPayload?.vd_saved_design_id
        ) {
          legacyReorderImportSettled = true;
          legacyReorderRetryTimers.forEach((timer) => window.clearTimeout(timer));
        }
        return;
      }

      if (data.type === "CHAMELEON_LEGACY_REORDER_READY") {
        if (data.bridgeVersion === BRIDGE_VERSION) sendLegacyReorderImport();
        return;
      }

      if (frame.__vdNativeRuntime && (data.type === "CHAMELEON_STUDIO_HEIGHT" || data.type === "CHAMELEON_SIMPLE_DEAL_HEIGHT")) return;
      if (data.type === "CHAMELEON_STUDIO_HEIGHT") {
        if (!window.matchMedia("(min-width: 1181px)").matches) return;
        const requestedHeight = Number(data.height || 0);
        if (!Number.isFinite(requestedHeight) || requestedHeight < 520 || requestedHeight > 5000) return;
        const appliedHeight = Math.ceil(requestedHeight);
        block.dataset.chameleonContentHeight = String(appliedHeight);
        block.style.setProperty("--chameleon-studio-height", `${appliedHeight}px`);
        frame.setAttribute("scrolling", "no");
        postToStudio({ type: "CHAMELEON_STUDIO_HEIGHT_APPLIED", height: appliedHeight });
        return;
      }

      if (data.type === "CHAMELEON_CART_OPEN") {
        const requestId = String(data.requestId || "");
        const jobId = String(data.jobId || "");
        const lineKey = String(data.lineKey || "");
        const reply = (ok, message = "") =>
          postToStudio({
            type: "CHAMELEON_CART_OPEN_RESULT",
            requestId,
            ok,
            message,
            jobId,
            lineKey,
          });

        if (!requestId || !jobId || !lineKey || data.bridgeVersion !== BRIDGE_VERSION) {
          reply(false, "The CHAMELEON checkout bridge request is not valid.");
          return;
        }

        try {
          const { line } = await findVerifiedLine(jobId);
          if (!line || String(line.key || "") !== lineKey) {
            throw new Error("The approved design is no longer in this Shopify cart.");
          }
          reply(true);
          window.setTimeout(openVerifiedCart, 60);
        } catch (error) {
          reply(false, error instanceof Error ? error.message : "Shopify could not verify the cart.");
        }
        return;
      }

      if (data.type !== "CHAMELEON_CART_ADD") return;

      const requestId = String(data.requestId || "");
      const requestedVariantId = Number(data.variantId || 0);
      const sourceProperties =
        data.properties && typeof data.properties === "object"
          ? data.properties
          : {};

      const fail = (message) =>
        postToStudio({
          type: "CHAMELEON_CART_RESULT",
          requestId,
          ok: false,
          message,
        });

      if (!requestId || data.bridgeVersion !== BRIDGE_VERSION) {
        fail("The CHAMELEON checkout bridge version is not valid.");
        return;
      }

      const isLegacy1003Request =
        configuredDealHandle === "100-3-custom-vinyl-stickers" &&
        configuredVariantId === 51215684698415 &&
        requestedVariantId === 58167178395951;
      const customSaleVariants = {
  "25:white-vinyl:gloss": [
    54257638801711,
    946
  ],
  "25:white-vinyl:matte": [
    54257638834479,
    946
  ],
  "25:white-vinyl:galaxy-stars": [
    54257638867247,
    2364
  ],
  "25:oil-slick:gloss": [
    54257638900015,
    2364
  ],
  "25:oil-slick:matte": [
    54257638932783,
    2364
  ],
  "25:oil-slick:galaxy-stars": [
    54257638965551,
    3781
  ],
  "25:glow-in-dark:gloss": [
    54257638998319,
    3781
  ],
  "25:glow-in-dark:matte": [
    54257639031087,
    3781
  ],
  "25:glow-in-dark:galaxy-stars": [
    54257639063855,
    5199
  ],
  "50:white-vinyl:gloss": [
    54257639096623,
    1796
  ],
  "50:white-vinyl:matte": [
    54257639129391,
    1796
  ],
  "50:white-vinyl:galaxy-stars": [
    54257639162159,
    4490
  ],
  "50:oil-slick:gloss": [
    54257639194927,
    4490
  ],
  "50:oil-slick:matte": [
    54257639227695,
    4490
  ],
  "50:oil-slick:galaxy-stars": [
    54257639260463,
    7183
  ],
  "50:glow-in-dark:gloss": [
    54257639293231,
    7183
  ],
  "50:glow-in-dark:matte": [
    54257639325999,
    7183
  ],
  "50:glow-in-dark:galaxy-stars": [
    54257639358767,
    9876
  ],
  "100:white-vinyl:gloss": [
    54257639391535,
    2458
  ],
  "100:white-vinyl:matte": [
    54257639424303,
    2458
  ],
  "100:white-vinyl:galaxy-stars": [
    54257639457071,
    6143
  ],
  "100:oil-slick:gloss": [
    54257639489839,
    6143
  ],
  "100:oil-slick:matte": [
    54257639522607,
    6143
  ],
  "100:oil-slick:galaxy-stars": [
    54257639555375,
    9829
  ],
  "100:glow-in-dark:gloss": [
    54257639588143,
    9829
  ],
  "100:glow-in-dark:matte": [
    54257639620911,
    9829
  ],
  "100:glow-in-dark:galaxy-stars": [
    54257639653679,
    13515
  ]
};
      const customSaleKey = [sourceProperties["_CHAMELEON Sticker Quantity"], sourceProperties["_CHAMELEON Material"], sourceProperties["_CHAMELEON Laminate"]].join(":");
      const customSaleSelection = customSaleVariants[customSaleKey];
      const isVerifiedCustomSale = configuredDealHandle === "custom-sticker-sale" && customSaleSelection && requestedVariantId === customSaleSelection[0] && Number(sourceProperties["_CHAMELEON Intended Price Cents"]) === customSaleSelection[1];
      if (configuredDealHandle === "custom-sticker-sale" ? !isVerifiedCustomSale : requestedVariantId !== configuredVariantId && !isLegacy1003Request) {
        fail(
          "The Custom Sticker variant does not match the verified Shopify carrier.",
        );
        return;
      }

      const properties = {};

      for (const [name, value] of Object.entries(sourceProperties)) {
        if (!ALLOWED_PROPERTIES.has(name)) continue;
        properties[name] = String(value ?? "").slice(0, 28000);
      }

      const missing = requiredPropertiesFor(properties).filter(
        (name) => !properties[name],
      );

      if (missing.length > 0) {
        fail(
          `The approved design is missing required production data: ${missing.join(", ")}.`,
        );
        return;
      }

      const jobId = properties["_CHAMELEON Checkout Job ID"];
      const expectedCents = Number.parseInt(
        properties["_CHAMELEON Intended Price Cents"],
        10,
      );
      const proofStatus =
        properties["_CHAMELEON Proof Status"];

      if (
        !jobId ||
        jobId.length > 160 ||
        !Number.isSafeInteger(expectedCents) ||
        expectedCents <= 0 ||
        expectedCents > 1000000000
      ) {
        fail("The CHAMELEON checkout job or expected price is invalid.");
        return;
      }

      if (!["approved", "manual"].includes(proofStatus)) {
        fail(
          "Approve the proof or request Manual Proof before adding this design.",
        );
        return;
      }

      if (
        properties["_CHAMELEON Cart Bridge Version"] !==
        BRIDGE_VERSION
      ) {
        fail("The line-item bridge version does not match the host.");
        return;
      }

      const compactAuthorization = JSON.stringify({
        v: properties["_CHAMELEON Cart Bridge Version"],
        d: properties["_CHAMELEON Design ID"],
        f: properties["_CHAMELEON Proof Fingerprint"],
        s: properties["_CHAMELEON Proof Status"],
        w: properties["_CHAMELEON Width"],
        h: properties["_CHAMELEON Height"],
        q: properties["_CHAMELEON Sticker Quantity"],
        m: properties["_CHAMELEON Material"],
        l: properties["_CHAMELEON Laminate"],
        c: properties["_CHAMELEON Intended Price Cents"],
        o: properties["_CHAMELEON Original Master SHA256"],
        x: properties["_CHAMELEON Original Color Mode"],
        p: properties["_Pricing version"] || properties["Pricing version"],
        e: properties["_CHAMELEON Deal Handle"] || "",
      });
      const checkoutProperties = {};
      const sourceProductMatch = window.location.pathname.match(/\/products\/([a-z0-9][a-z0-9-]*)\/?$/);
      if (sourceProductMatch) {
        const sourceHandle = sourceProductMatch[1];
        checkoutProperties['_VD Source Product Handle'] = sourceHandle;
        try {
          const sourceResponse = await fetch(root + 'products/' + sourceHandle + '.js', {credentials:'same-origin',signal:AbortSignal.timeout(5000)});
          if (sourceResponse.ok) {
            const sourceProduct = await sourceResponse.json();
            if (sourceProduct.handle === sourceHandle && typeof sourceProduct.title === 'string' && sourceProduct.title) checkoutProperties['_VD Source Product Title'] = sourceProduct.title;
          }
        } catch {}
      }
      const staffProperties = [
        "Finished size",
        "Material",
        "Laminate",
        "Shape",
        "Proof status",
        "Sticker quantity",
        "Price per sticker",
        "Manual proof notes",
        "Approved proof",
        "Approval",
    "Notes for our team",
    "Instagram shoutout (opt-in)",
        "Package",
        "Wrap quantity",
        "Package total price",
        "Price per pair",
        "Hole guide",
        "Deal",
        "Deal terms",
      ];
      staffProperties.forEach((name) => {
        if (properties[name]) checkoutProperties[name] = properties[name];
      });
      checkoutProperties["_CHAMELEON Checkout Job ID"] = jobId;
      checkoutProperties["_CHAMELEON Authorization"] = compactAuthorization;
      checkoutProperties["_CHAMELEON Studio Return URL"] =
        properties["_CHAMELEON Studio Return URL"] || `${studioOrigin}/create`;
      checkoutProperties["_CHAMELEON Preview URL"] =
        properties["_CHAMELEON Preview URL"] ||
        `${studioOrigin}/api/intake/jobs/${encodeURIComponent(jobId)}/preview`;
      if (properties["_CHAMELEON Preview Alt"]) {
        checkoutProperties["_CHAMELEON Preview Alt"] =
          properties["_CHAMELEON Preview Alt"];
      }
      [
        "_CHAMELEON Width",
        "_CHAMELEON Height",
        "_CHAMELEON Sticker Quantity",
        "_CHAMELEON Material",
        "_CHAMELEON Laminate",
        "_CHAMELEON Intended Price Cents",
        "_CHAMELEON Cart Bridge Version",
        "_CHAMELEON Deal Handle",
        "_CHAMELEON Approved Proof URL",
        "_CHAMELEON Approved At",
      ].forEach((name) => {
        if (properties[name]) checkoutProperties[name] = properties[name];
      });
      checkoutProperties["Pricing version"] =
        properties["_Pricing version"] || properties["Pricing version"];

function manualProofFields(properties){
 const noteKeys=Object.keys(properties).filter(key=>/^(manual proof notes|notes for our team|customer notes)$/i.test(key));
 const status=String(properties['Proof status']||properties['_CHAMELEON Proof Status']||'');
 if(status&&!/manual/i.test(status))return properties;
 const lines=noteKeys.flatMap(key=>typeof properties[key]==='string'?properties[key].split(/\r?\n/):[]);
 const noBorder=lines.includes('No white border'),reorder=lines.includes('Reorder requested');
 if(!noBorder&&!reorder)return properties;
 const numberPattern=/^Previous order number: ([a-zA-Z0-9#-]{1,40})$/;
 const previous=reorder?lines.map(line=>line.match(numberPattern)?.[1]).find(Boolean):'';
 if(noBorder)properties['White Border']||='No';
 if(reorder)properties.Reorder||=previous||'Requested';
 for(const key of noteKeys){
  if(typeof properties[key]!=='string')continue;
  properties[key]=properties[key].split(/\r?\n/).filter(line=>!(noBorder&&line==='No white border')&&!(reorder&&(line==='Reorder requested'||numberPattern.test(line)))).join('\n').trim();
 }
 return properties;
}

manualProofFields(checkoutProperties);
for (const name of Object.keys(checkoutProperties)) {
  if (/^(manual proof notes|notes for our team|customer notes)$/i.test(name) && checkoutProperties[name] === '') delete checkoutProperties[name];
}
      try {
        const addResponse = await fetch(`${root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: isVerifiedCustomSale ? requestedVariantId : configuredVariantId,
                quantity: 1,
                properties: checkoutProperties,
              },
            ],
          }),
        });

        const addBody = await addResponse.json().catch(() => null);

        if (!addResponse.ok) {
          throw new Error(
            addBody?.description ||
              addBody?.message ||
              "Shopify could not add this design to the cart.",
          );
        }

        const { cart, line } = await findVerifiedLine(jobId);

        if (!line) {
          throw new Error(
            "Shopify added the item but the verified CHAMELEON job could not be found.",
          );
        }

        const actualCents = Number(line.final_line_price);
        const currency = String(cart.currency || "USD").toUpperCase();
        const activeCurrency = String(
          window.Shopify?.currency?.active || "USD",
        ).toUpperCase();
        const presentmentRate = Number(window.Shopify?.currency?.rate ?? 1);
        const expectedPresentmentCents =
          currency === "USD"
            ? expectedCents
            : activeCurrency === currency &&
                Number.isFinite(presentmentRate) &&
                presentmentRate > 0
              ? Math.round(expectedCents * presentmentRate)
              : null;
        const originalCents = Number(
          line.original_line_price ?? line.original_price,
        );
        const discountCents = Array.isArray(line.discounts)
          ? line.discounts.reduce(
              (sum, discount) => sum + Number(discount?.amount || 0),
              0,
            )
          : 0;
        const customSaleMarketTolerance =
          expectedPresentmentCents === null
            ? 0
            : Math.max(50, Math.ceil(expectedPresentmentCents * 0.01));
        const customSaleMarketPriceVerified =
          Boolean(isVerifiedCustomSale) &&
          Number(line.variant_id) === requestedVariantId &&
          Number.isSafeInteger(originalCents) &&
          originalCents > 0 &&
          Number.isSafeInteger(discountCents) &&
          discountCents >= Math.floor(originalCents * 0.599) &&
          originalCents - discountCents === actualCents &&
          actualCents > 0 &&
          expectedPresentmentCents !== null &&
          actualCents <=
            expectedPresentmentCents + customSaleMarketTolerance;
        const exactPresentmentPriceVerified =
          expectedPresentmentCents !== null &&
          actualCents === expectedPresentmentCents;

        if (
          !exactPresentmentPriceVerified &&
          !customSaleMarketPriceVerified
        ) {
          await removeUnsafeLine(line.key);
          const expectedPrice =
            expectedPresentmentCents === null
              ? "the verified converted amount"
              : currency + " " + (expectedPresentmentCents / 100).toFixed(2);
          throw new Error(
            "Shopify blocked this cart line because the verified price did not apply. The unsafe carrier-price line was removed automatically. Expected " +
              expectedPrice +
              ".",
          );
        }
        const lineProperties = line.properties || {};
        const missingAfterAdd = Object.keys(checkoutProperties).filter(
          (name) => !lineProperties[name],
        );

        if (missingAfterAdd.length > 0) {
          await removeUnsafeLine(line.key);
          throw new Error(
            `Shopify dropped required production data and the incomplete cart line was removed: ${missingAfterAdd.join(", ")}.`,
          );
        }

        postToStudio({
          type: "CHAMELEON_CART_RESULT",
          requestId,
          ok: true,
          jobId,
          lineKey: line.key,
          actualFinalLinePriceCents: actualCents,
          currency,
        });

        if (data.redirectToCart !== false) {
          window.setTimeout(openVerifiedCart, 60);
        }
      } catch (error) {
        fail(
          error instanceof Error
            ? error.message
            : "Shopify could not add this approved design to the cart.",
        );
      }
    };window.addEventListener("message",receive);if(frame.__vdNativeRuntime)block.addEventListener("vd:c1:message",event=>{if(event.target!==frame||event.detail?.runtime!==frame.__vdNativeRuntime)return;receive({source:frame.__vdNativeRuntime,nativeValidated:true,data:event.detail.data});});})();

    if (frame.__vdNativeStart) frame.__vdNativeStart();
    if (legacyReorderPayload && !privateMode) {
      [0, 250, 1000, 2500].forEach((delay) => {
        legacyReorderRetryTimers.push(
          window.setTimeout(sendLegacyReorderImport, delay),
        );
      });
    }
  }
})();



/* CHAMELEON_ANDROID_PARENT_PAGE_SCROLL_HANDOFF */
(() => {
  const blocks = Array.from(document.querySelectorAll("[data-chameleon-shopify-studio]:not([data-chameleon-private-studio])"));
  if (blocks.length === 0) return;

  const frameForSource = (source) => blocks
    .map((block) => ({ block, frame: block.querySelector("iframe") }))
    .find(({ frame }) => frame?.contentWindow === source);

  const postScrollState = (entry) => {
    if (!entry?.frame?.contentWindow) return;
    let targetOrigin = "*";
    try {
      targetOrigin = new URL(entry.frame.src, window.location.href).origin;
    } catch {
      targetOrigin = "*";
    }
    const visualViewport = window.visualViewport;
    const viewportTop = Number(visualViewport?.offsetTop || 0);
    entry.frame.contentWindow.postMessage({
      type: "CHAMELEON_PAGE_SCROLL_STATE",
      frameTop: entry.frame.getBoundingClientRect().top - viewportTop,
      pageScrollY: window.scrollY,
      viewportHeight: Number(visualViewport?.height || window.innerHeight)
    }, targetOrigin);
  };

  const reportAllScrollStates = () => {
    blocks.forEach((block) => postScrollState({ block, frame: block.querySelector("iframe") }));
  };

  window.addEventListener("message", (event) => {
    const entry = frameForSource(event.source);
    if (!entry?.frame) return;
    let expectedOrigin = "";
    try {
      expectedOrigin = new URL(entry.frame.src, window.location.href).origin;
    } catch {
      return;
    }
    if (event.origin !== expectedOrigin) return;

    if (event.data?.type === "CHAMELEON_PAGE_SCROLL_STATE_REQUEST") {
      postScrollState(entry);
      return;
    }
    if (event.data?.type !== "CHAMELEON_PAGE_SCROLL_DELTA") return;

    const deltaY = Number(event.data.deltaY || 0);
    if (!Number.isFinite(deltaY) || Math.abs(deltaY) > 160) return;
    const frameTop = entry.frame.getBoundingClientRect().top - Number(window.visualViewport?.offsetTop || 0);
    const allowedDelta = deltaY > 0
      ? Math.min(deltaY, Math.max(0, frameTop))
      : Math.max(deltaY, -window.scrollY);
    if (allowedDelta === 0) {
      postScrollState(entry);
      return;
    }
    window.scrollBy(0, allowedDelta);
    window.requestAnimationFrame(() => postScrollState(entry));
  });

  window.addEventListener("scroll", reportAllScrollStates, { passive: true });
  window.addEventListener("resize", reportAllScrollStates, { passive: true });
  window.visualViewport?.addEventListener("resize", reportAllScrollStates, { passive: true });
  window.visualViewport?.addEventListener("scroll", reportAllScrollStates, { passive: true });
  blocks.forEach((block) => block.querySelector("iframe")?.addEventListener("load", reportAllScrollStates));
  window.setTimeout(reportAllScrollStates, 0);
  window.setTimeout(reportAllScrollStates, 500);
})();



})();